import React from "react";

// Iter60.p58 — Shared worker-type badge (extracted from PayrollPeriod so
// the Attendance grid can render the same taxonomy without a second
// copy). Taxonomy locked by p51:
//   - `casual`                  → navy pill
//   - `non_casual_manual`       → crimson pill
//   - `non_casual_non_manual`   → violet pill
//   - anything else (legacy)    → grey pill with the raw string
export function workerTypeLabel(cat) {
    switch ((cat || "").toLowerCase()) {
        case "casual": return "Casual";
        case "non_casual_manual": return "Non-Casual · Manual";
        case "non_casual_non_manual": return "Non-Casual · Non-Manual";
        default: return cat || "—";
    }
}

export function deriveWorkerCategory(employmentType, workerSubtype) {
    const et = (employmentType || "").toLowerCase();
    if (et === "casual") return "casual";
    if (et === "non_casual") {
        const st = (workerSubtype || "").toLowerCase();
        return st === "non_manual" ? "non_casual_non_manual" : "non_casual_manual";
    }
    return "";
}

export default function WorkerTypeBadge({ category, testid }) {
    const label = workerTypeLabel(category);
    const c = (category || "").toLowerCase();
    const tone =
        c === "casual"
            ? { bg: "#EEF3FF", fg: "#1B2A56", border: "#C9D4F0" }
            : c === "non_casual_manual"
                ? { bg: "#FEF2F4", fg: "#A8324A", border: "#F3C7D0" }
                : c === "non_casual_non_manual"
                    ? { bg: "#F6EAFB", fg: "#5A2A80", border: "#E0C8F0" }
                    : { bg: "#F5F6F8", fg: "#1A1A1A", border: "#E5E7EB" };
    return (
        <span
            data-testid={testid || "worker-type-badge"}
            className="inline-flex items-center rounded-full px-2 py-0.5 text-[10px] font-semibold whitespace-nowrap"
            style={{ background: tone.bg, color: tone.fg, border: `1px solid ${tone.border}` }}
        >
            {label}
        </span>
    );
}
